import React from 'react'
import MainPage from '../components/MainPage';
import NavBar from '../components/NavBar';

const Layout = () => {
  return (
    <div>
      <NavBar/>
      <MainPage/>
    </div>
  )
}

export default Layout